// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"featuresHighlights-module--cardsContainer--3sRtZ","featuresHighlightsSection":"featuresHighlights-module--featuresHighlightsSection--3hTUQ"};